export default __webpack_public_path__ + "images/b2.9c472e4.png";